import React from 'react'
import FetchData from '../../shared/fetchData'
import './Faq.css'
import Button from '../UI/Button/Button'
import Modal from '../UI/Modal/Modal'
import Input from '../UI/Input/Input'
import {updateObject, checkValidity}
from '../../shared/utility'
import Add from '@material-ui/icons/Add'

        const Faq = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [editTitle, setEditTitle] = React.useState(false)
    const [editContent, setEditContent] = React.useState(false)
    const [titles, setTitles] = React.useState([])
    const [titleId, setTitleId] = React.useState('')
    const [contentId, setContentId] = React.useState('')
    const [title, setTitle] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'موضوع'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })
    const [content, setContent] = React.useState({
        question: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'سوال'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }, response: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'پاسخ'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })
    const [contents, setContents] = React.useState([])
    const [editContents, setEditContents] = React.useState([])

    const childRef = React.useRef()
    const stateRef = React.useRef()
    const conRef = React.useRef()
    const conStateRef = React.useRef()

    React.useEffect(() => {
        var raw = JSON.stringify({
            "version": "mtpx001",
            "pl": '10000',
            "pn": '1',
        })
        var url = 'management/api/v1/contents/getFaqTitles'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setTitles(result.faqTitles)
                    }
                })
                .catch(error => setLoading(false))
    }, [])

    const insertUpdateTitle = (event, id, isUpdate) => {
        setTitleId(id)
        if (isUpdate) {
            setEditTitle(true)
            const tt = titles.filter(t => t.id == id)
            if (tt != null && tt.length != 0) {
                const tit = title
                tit.description.value = tt[0].description
                tit.description.valid = true
                setTitle(tit)
                if (changeForm) {
                    setChangeForm(false)
                } else {
                    setChangeForm(true)
                }
                childRef.current.openModal()
            }
        } else {
            setEditTitle(false)
            const tit = title
            tit.description.value = ""
            setTitle(tit)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
            childRef.current.openModal()
        }
    }
    const insertUpdateContent = (event, id, isUpdate) => {
        setContentId(id)
        if (isUpdate) {
            setEditContent(true)
            const cn = contents.filter(t => t.id == id)
            if (cn != null && cn.length != 0) {
                const c = content
                c.question.value = cn[0].question
                c.question.valid = true
                c.response.value = cn[0].response
                c.response.valid = true
                setContent(c)
                if (changeForm) {
                    setChangeForm(false)
                } else {
                    setChangeForm(true)
                }
                conRef.current.openModal()
            }
        } else {
            setEditContent(false)
            const c = content
            c.question.value = ""
            c.response.value = ""
            setContent(c)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
            conRef.current.openModal()
        }
    }
    const insertUpdateTitleSubmit = (event) => {
        var raw = ''
        var url = ''
        let valid = true
        const tt = title
        if (tt.description.value == '') {
            tt.description.valid = false
            valid = false
        }
        if (valid) {
            if (editTitle) {
                raw = JSON.stringify({
                    "faqTitle": {
                        "id": titleId,
                        "description": title.description.value
                    },
                    "version": "mtpx001"
                })
                url = 'management/api/v1/contents/updateFaqTitle'
            } else {
                raw = JSON.stringify({
                    "faqTitle": {
                        "description": title.description.value
                    },
                    "version": "mtpx001"
                })
                url = 'management/api/v1/contents/insertFaqTitle'
            }
            setLoading(true)
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            childRef.current.closeModal()
                            var raw = JSON.stringify({
                                "pl": '10000',
                                "pn": '1',
                                "version": "mtpx001"
                            })
                            var url = 'management/api/v1/contents/getFaqTitles'
                            setLoading(true)
                            FetchData(raw, url).then(response => response.json())
                                    .then(result => {
                                        setLoading(false)
                                        if (result.status == 0) {
                                            setTitles(result.faqTitles)
                                        }
                                    })
                                    .catch(error => setLoading(false))
                        }
                    })
                    .catch(error => setLoading(false))
        } else {
            setTitle(tt)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        }
    }
    const contentChangeState = (event, id) => {
        setContentId(id)
        conStateRef.current.openModal()
    }
    const titleChangeState = (event, id) => {
        setTitleId(id)
        stateRef.current.openModal()
    }
    const titleChangeStateSubmit = (event) => {

        var raw = JSON.stringify({
            "faqTitle": {
                "id": titleId
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/changeFaqTitleState'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        stateRef.current.closeModal()
                        var raw = JSON.stringify({
                            "pl": '10000',
                            "pn": '1',
                            "version": "mtpx001"
                        })
                        var url = 'management/api/v1/contents/getFaqTitles'
                        setLoading(true)
                        FetchData(raw, url).then(response => response.json())
                                .then(result => {
                                    setLoading(false)
                                    if (result.status == 0) {
                                        setTitles(result.faqTitles)
                                    }
                                })
                                .catch(error => setLoading(false))
                    }
                })
                .catch(error => setLoading(false))
    }
    const contentChangeStateSubmit = (event) => {

        var raw = JSON.stringify({
            "faqContent": {
                "id": contentId
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/changeFaqContentState'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        conStateRef.current.closeModal()
                        var raw = JSON.stringify({
                            "faqContent": {
                                "faqTitleId": titleId
                            },
                            "pl": '10000',
                            "pn": '1',
                            "version": "mtpx001"
                        })
                        var url = 'management/api/v1/contents/getFaqContents'
                        setLoading(true)
                        FetchData(raw, url).then(response => response.json())
                                .then(result => {
                                    conRef.current.closeModal()
                                    setLoading(false)
                                    if (result.status == 0) {
                                        setContents(result.faqContents)
                                        setEditContents(result.faqContents)
                                    }
                                })
                                .catch(error => setLoading(false))
                    }
                })
                .catch(error => setLoading(false))
    }
    const showContents = (event, id) => {
        setTitleId(id)
        var raw = JSON.stringify({
            "faqContent": {
                "faqTitleId": id
            },
            "pl": '10000',
            "pn": '1',
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/getFaqContents'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setContents(result.faqContents)
                        setEditContents(result.faqContents)
                    }
                })
                .catch(error => setLoading(false))
    }

    const titleInputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(title, {
            [controlName]: updateObject(title[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, title[controlName].validation),
                errorMessage: title[controlName].elementConfig.placeholder + ' صحیح نیست'
            })
        });
        setTitle(updatedControls)
    }

    const contentInputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(content, {
            [controlName]: updateObject(content[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, content[controlName].validation),
                errorMessage: content[controlName].elementConfig.placeholder + ' صحیح نیست'
            })
        });
        setContent(updatedControls)
    }
    const insertUpdateContentSubmit = (event) => {

        var raw = ''
        var url = ''
        let valid = true
        const cn = content
        if (cn.question.value == '' || cn.response.value == '') {
            cn.question.valid = false
            cn.response.valid = false
            valid = false
        }
        if (valid) {
            if (editContent) {
                raw = JSON.stringify({
                    "faqContent": {
                        "id": contentId,
                        "faqTitleId": titleId,
                        "question": content.question.value,
                        "response": content.response.value
                    },
                    "version": "mtpx001"
                })
                url = 'management/api/v1/contents/updateFaqContent'
            } else {
                raw = JSON.stringify({
                    "faqContent": {
                        "faqTitleId": titleId,
                        "question": content.question.value,
                        "response": content.response.value
                    },
                    "version": "mtpx001"
                })
                url = 'management/api/v1/contents/insertFaqContent'
            }
            setLoading(true)
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            var raw = JSON.stringify({
                                "faqContent": {
                                    "faqTitleId": titleId
                                },
                                "pl": '10000',
                                "pn": '1',
                                "version": "mtpx001"
                            })
                            var url = 'management/api/v1/contents/getFaqContents'
                            setLoading(true)
                            FetchData(raw, url).then(response => response.json())
                                    .then(result => {
                                        conRef.current.closeModal()
                                        setLoading(false)
                                        if (result.status == 0) {
                                            setContents(result.faqContents)
                                            setEditContents(result.faqContents)
                                        }
                                    })
                                    .catch(error => setLoading(false))
                        }
                    })
                    .catch(error => setLoading(false))
        } else {
            setTitle(cn)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        }


    }
    const afterCloseModal = (event) => {
    }

    const titleList = titles != null && titles.length != 0 ?
            titles.map(t => {
                return(
                        <div className="col-4 full-small mt-2">
                            <div className={titleId != '' && titleId == t.id ? "title-selected" : "title"}>
                                <div className="col-8 mt-2">
                                    {t.description}
                                </div>
                                <div className="col-4 text-left p-0">
                                    <Button btnType="Edit" clicked={(event) => insertUpdateTitle(event, t.id, true)} >ویرایش</Button>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-6 text-left">
                                    <Button btnType="Dark-Grid" clicked={(event) => showContents(event, t.id)} >سوالات</Button>
                                </div>
                                <div className="col-6">
                                    <Button btnType="Grid" clicked={(event) => titleChangeState(event, t.id)}><span  className={t.isActive == '1' ? "active-titile" : ""}>تغییر وضعیت </span></Button>
                                </div>
                            </div>
                        </div>
                        )
            })
            : ''
    const contentList = contents != null && contents.length != 0 ?
            contents.map(c => {
                return (
                        <div style={{width: '100%'}}>
                            <div className="col-12 mt-4">
                                <div className="qstn">
                                    {c.question}
                                </div>
                                <div className="res">
                                    {c.response}
                                </div>
                            </div>
                            <div style={{display: 'flex'}}>
                                <div className="col-2 mr-5 hulf-small">
                                    <Button btnType="Dark-Grid" clicked={(event) => insertUpdateContent(event, c.id, true)} >ویرایش</Button>
                                </div>
                                <div className="col-2 hulf-small">
                                    <Button btnType="Grid" clicked={(event) => contentChangeState(event, c.id)} ><span  className={c.isActive == '1' ? "active-titile" : ""}>تغییر وضعیت</span></Button>
                                </div>
                            </div>
                        </div>
                        )
            })
            : ''
    const formElementsArray = [];
    for (let key in title) {
        formElementsArray.push({
            id: key,
            config: title[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    col="12 mt-3"
                    changed={(event) => titleInputChangedHandler(event, formElement.id)} />
                );
    })

    const modalContent = <div>
        <div className="row justify-content-center">
            {form}
        </div>
        <div className="row justify-content-center">
            <Button btnType="Success" clicked={insertUpdateTitleSubmit} >ثبت</Button>
        </div>
    </div>
    const titleStateContent = <div>
        <div className="row justify-content-center">
            آیا از تغییر وضعیت راضی هستید؟
        </div>
        <div className="row justify-content-center mt-3">
            <Button btnType="Success" clicked={titleChangeStateSubmit} >ثبت</Button>
        </div>
    </div>
    const contentStateContent = <div>
        <div className="row justify-content-center">
            آیا از تغییر وضعیت راضی هستید؟
        </div>
        <div className="row justify-content-center mt-3">
            <Button btnType="Success" clicked={contentChangeStateSubmit} >ثبت</Button>
        </div>
    </div>
    const formElementsArrayCon = [];
    for (let key in content) {
        formElementsArrayCon.push({
            id: key,
            config: content[key]
        });
    }
    let formCon = formElementsArrayCon.map(formElement => {
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    col="12 mt-3"
                    changed={(event) => contentInputChangedHandler(event, formElement.id)} />
                );
    })

    const contentContent = <div>
        <div className="row justify-content-center">
            {formCon}
        </div>
        <div className="row justify-content-center">
            <Button btnType="Success" clicked={insertUpdateContentSubmit} >ثبت</Button>
        </div>
    </div>

    return (
            <div className="row" dir="rtl">
                <div className="col-12">
                    <div onClick={(event) => insertUpdateTitle(event, "", false)} className="Add">
                        <Add className="UserIcon" />
                    </div>
                </div>
                {titleList}
                <div className="row justify-content-center mt-3">
                    <hr/>
                </div>
                {titleId != '' ?
                            <div className="col-12">
                                <div onClick={(event) => insertUpdateContent(event, "", false)} className="Add">
                                    <Add className="UserIcon" />
                                </div>
                            </div>
                            : ''}
                {contentList}
                <Modal
                    content={modalContent}
                    ref={childRef}
                    closePermission="true"
                    closeModal={(event) => afterCloseModal(event)}
                    />
                <Modal
                    content={titleStateContent}
                    ref={stateRef}
                    closePermission="true"
                    closeModal={(event) => afterCloseModal(event)}
                    />
                <Modal
                    content={contentContent}
                    ref={conRef}
                    closePermission="true"
                    closeModal={(event) => afterCloseModal(event)}
                    />
                <Modal
                    content={contentStateContent}
                    ref={conStateRef}
                    closePermission="true"
                    closeModal={(event) => afterCloseModal(event)}
                    />
            </div>
            )
}

export default Faq